module.exports = __webpack_public_path__ + "static/media/basic.87acf1a9.svg";